/**
 * `/flights/:id/:tab?` — the workspace, with the inspector's tab in the path.
 *
 * The tab is a route and not a piece of state on purpose: the back button then
 * does what a pilot expects, a banner can link straight to `…/terrain`, and a
 * screenshot of the address bar says which view it was.
 */
import { useCallback } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import FlightWorkspace from '../app/FlightWorkspace';
import { DEFAULT_TAB, tabOf, type TabKey } from '../app/tabs';

export default function Flight() {
  const { id, tab } = useParams<{ id: string; tab?: string }>();
  const navigate = useNavigate();

  const onTab = useCallback(
    (next: TabKey) => {
      if (!id) return;
      navigate('/flights/' + id + (next === DEFAULT_TAB ? '' : '/' + next), { replace: true });
    },
    [id, navigate],
  );

  if (!id) return <Navigate to="/flights" replace />;
  return <FlightWorkspace planId={id} tab={tabOf(tab)} onTab={onTab} />;
}
